module.exports = __webpack_public_path__ + "img/feyenoord-logo-icon.6296f5c8.png";